module.exports = __webpack_public_path__ + "img/module2_icon1.b172f1ad.png";